import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class NumbersOnlyDirective {

  // Regular expression to allow only numbers (digits 0-9)
  private regex: RegExp = new RegExp('^[0-9]+$');

  // Regular expression to detect emojis
  private emojiRegex: RegExp = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2B50}-\u{2B55}|\u{23F0}-\u{23F3}|\u{2B06}-\u{2B07}|\u{2B05}-\u{2B07}]/u;

  constructor(private el: ElementRef) {}

  // Listen for the 'keypress' event to restrict input to numbers and block emojis
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const key = event.key;

    // Prevent if the key is not a number or is an emoji
    if (!this.regex.test(key) || this.emojiRegex.test(key)) {
      event.preventDefault();
    }
  }

  // Listen for the 'input' event to sanitize input and remove emojis and non-numeric characters
  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const value = inputElement.value;

    // Replace any emoji and non-numeric characters from the input
    const sanitizedValue = value.replace(this.emojiRegex, '').replace(/[^0-9]/g, '');

    if (value !== sanitizedValue) {
      inputElement.value = sanitizedValue; // Update input field with sanitized value
    }
  }

  // Listen for the 'paste' event to restrict pasted content to numbers and block emojis
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    // Get the pasted text from the clipboard
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');

    // If pasted text contains non-numeric characters or emojis, prevent the paste
    if (!this.regex.test(pastedText) || this.emojiRegex.test(pastedText)) {
      event.preventDefault();

      // Optionally, replace the invalid pasted text with just the numeric part
      const sanitizedText = pastedText.replace(this.emojiRegex, '').replace(/[^0-9]/g, '');
      if (sanitizedText) {
        const currentValue = this.el.nativeElement.value;
        this.el.nativeElement.value = currentValue + sanitizedText; // Append sanitized text
      }
    }
  }
}
